import isAfter from 'date-fns/isAfter';

export const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email)
}

export const numStrSort = (key) => (rowA, rowB) => {
    const firstNumber = Number(rowA.original[key].replace(",", ""))
    const secondNumber = Number(rowB.original[key].replace(",", ""))
    return firstNumber > secondNumber ? 1 : -1
}

export const dateStrSort = (key) => (rowA, rowB) => {
    const firstDate = new Date(rowA.original[key])
    const secondDate = new Date(rowB.original[key])
    return isAfter(firstDate, secondDate) ? 1 : -1
}

const ROW_SELECTION_INDEX_SEPARATOR = '|'

export const buildTableRowId = (rowId, row, index) => {
    const baseId = rowId?.(row, index)
    if (baseId == null || baseId === '') {
        return String(index)
    }
    return `${baseId}${ROW_SELECTION_INDEX_SEPARATOR}${index}`
}

export const getRowSelectionBaseKey = (key) => {
    const separatorIndex = key.lastIndexOf(ROW_SELECTION_INDEX_SEPARATOR)
    if (separatorIndex === -1) {
        return key
    }
    return key.slice(0, separatorIndex)
}
